import { Otd } from '@/app/otd/entities/otd.entity'

export interface OtdState {
    otds: Otd[]
}

export const state: OtdState = {
    otds: []
}
